module.exports = __webpack_public_path__ + "img/pt-8.315b8df0.jpg";